"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlgoliaEnhancedSearch = void 0;
exports.getRestrictSearchableAttributes = getRestrictSearchableAttributes;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _components = require("@insided/shared/services/algolia/components");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _common = require("@insided/shared/utils/common");

var _AlgoliaSearch = require("./AlgoliaSearch");

var _utils = require("../../utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchWithAutoComplete = (0, _connectors.connectAutoComplete)((0, _connectors.connectStateResults)(_AlgoliaSearch.AlgoliaSearch)); // Content attributes searched in normal (non-numeric) queries. Order matters
// for Algolia's per-attribute ranking — earlier entries are weighted higher.

var CONTENT_SEARCHABLE_ATTRIBUTES = ['title', 'first_post', 'answer', 'reply', 'tags', 'forum_title', 'category_title', 'product_area_title', 'content']; // When the user types a pure-digit query, `searchById` flips on. We still
// want the fast "exact topic ID" lookup (id/private_id ranked first), but
// the previous implementation searched ONLY those two attributes — so a
// title like "Form 8949" never matched. Include the content attributes too;
// Algolia's per-attribute ranking keeps an exact ID hit at the top while
// also surfacing content matches.

function getRestrictSearchableAttributes(searchById) {
  if (searchById) {
    return ['id', 'private_id'].concat(CONTENT_SEARCHABLE_ATTRIBUTES);
  }

  return [].concat(CONTENT_SEARCHABLE_ATTRIBUTES);
}

/**
 * Algolia-enhanced search component
 *
 * This component handles all Algolia-specific functionality including:
 * - InstantSearch context and configuration
 * - Multi-index search setup (community, federated sources)
 * - Search state management (pagination, query tracking)
 * - Integration with autocomplete and results display
 *
 * @requires searchClient - Algolia client must be initialized before rendering this component
 */
var AlgoliaEnhancedSearch = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AlgoliaEnhancedSearch, _Component);

  var _super = _createSuper(AlgoliaEnhancedSearch);

  function AlgoliaEnhancedSearch() {
    var _this;

    (0, _classCallCheck2.default)(this, AlgoliaEnhancedSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      pageCount: 0,
      query: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchStateChangeHandler", function (searchState) {
      if (searchState.query !== _this.state.query) {
        _this.setState({
          pageCount: 0
        });
      }

      _this.setState({
        query: searchState.query
      });
    });
    return _this;
  }

  (0, _createClass2.default)(AlgoliaEnhancedSearch, [{
    key: "includedDataSources",
    get: function get() {
      return [this.props.isFederatedSkilljarSearch ? 'skilljar' : null, this.props.isFederatedSalesforceSearch ? 'salesforce' : null, this.props.isFederatedFreshdeskSearch ? 'freshdesk' : null, this.props.isZendeskFederatedSearch ? 'zendesk' : null, _common.common.isModuleActive('federatedSearchApi') ? 'federated' : null].filter(function (v) {
        return Boolean(v);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var pageCount = this.state.pageCount;
      var analyticsTags = (0, _utils.getAnalyticsTags)('live');
      var userToken = (0, _utils.getAnalyticsUserToken)();
      return (0, _preact.h)(_components.InstantSearch, {
        searchClient: props.searchClient,
        indexName: props.communityId,
        onSearchStateChange: this.searchStateChangeHandler
      }, (0, _preact.h)(_components.Index, {
        indexName: props.communityId
      }, (0, _preact.h)(_components.Configure, {
        page: pageCount,
        filters: (0, _utils.getFilters)(props, this.includedDataSources),
        queryType: props.searchById ? 'prefixNone' : 'prefixLast',
        clickAnalytics: true,
        analytics: true,
        analyticsTags: analyticsTags,
        userToken: userToken,
        restrictSearchableAttributes: getRestrictSearchableAttributes(props.searchById)
      })), (0, _preact.h)(SearchWithAutoComplete, {
        updateSearch: function updateSearch(value, next) {
          return props.updateSearch(value, next);
        },
        enableFocusToSearch: props.enableFocusToSearch,
        callbackOnOutsideClick: props.callbackOnOutsideClick,
        aiSearchSummary: props.aiSearchSummary,
        askAISearchSummary: props.askAISearchSummary,
        isGuest: props.isGuest,
        aiSmartSearchEnableForAllRoles: props.aiSmartSearchEnableForAllRoles,
        forethoughtAgent: props.forethoughtAgent,
        pageCount: pageCount,
        loadNextPage: function loadNextPage() {
          return _this2.setState({
            pageCount: pageCount + 1
          });
        } // Forward the hero's "Published in" + Product Area selections so
        // pressing Enter takes the same filters along to the full-page
        // search via the redirect URL (publishedIn/productArea query params).
        ,
        searchInContentCategories: props.searchInContentCategories,
        searchInProductAreas: props.searchInProductAreas
      }));
    }
  }]);
  return AlgoliaEnhancedSearch;
}(_preact.Component);

exports.AlgoliaEnhancedSearch = AlgoliaEnhancedSearch;